import { Navigate, Route as RouterRoute, Routes } from 'react-router-dom';
import { useAppContext } from 'src/contexts/AppContext';
import Page404 from 'src/pages/404Page';
import { DigitalAttributionPages } from 'src/pages/DigitalAttribution';
import { LongTermEffectsPages } from 'src/pages/LongTermEffects';
import { MarketingMixModellingPages } from 'src/pages/MarketingMixModelling';
import { MarketingOptimizationPages } from 'src/pages/MarketingOptimization';
import { ForecastingPages } from 'src/pages/Forecasting';
import { SettingsPage } from 'src/pages/Settings';
import { DataUploadPage } from 'src/pages/DataUpload';
import { AdminInviteUsersDashboard } from 'src/pages/AdminInviteUser';
import { GoalsPage } from 'src/pages/Goals';
import { BrandTrackingPages } from 'src/pages/BrandTracking';
import { InboxPage } from 'src/pages/Inbox';

const RootNavigation: React.FC = () => {
  const { subscriptionLevels } = useAppContext();

  if (subscriptionLevels.mm) {
    return <Navigate replace to="/mmm/overview" />;
  }

  if (subscriptionLevels.da) {
    return <Navigate replace to="/digital/overview" />;
  }

  if (subscriptionLevels.mo) {
    return <Navigate replace to="/marketing-optimization" />;
  }

  if (subscriptionLevels.lt) {
    return <Navigate replace to="/longterm-effect" />;
  }

  return null;
};

export const AppRoutes: React.FC = () => {
  const { subscriptionLevels, isSuperuser } = useAppContext();

  return (
    <Routes>
      {/* MM pages */}
      <RouterRoute
        path="/mmm/*"
        element={
          <MarketingMixModellingPages isSubscribed={subscriptionLevels.mm} />
        }
      />
      {/* Digital Attribution pages */}
      <RouterRoute
        path="/digital/*"
        element={
          <DigitalAttributionPages isSubscribed={subscriptionLevels.da} />
        }
      />

      {/* Marketing Optimization pages */}
      <RouterRoute
        path="/marketing-optimization"
        element={
          <MarketingOptimizationPages isSubscribed={subscriptionLevels.mo} />
        }
      />

      {/* Forecasting pages */}
      <RouterRoute
        path="/forecasting"
        element={<ForecastingPages isSubscribed={subscriptionLevels.mo} />}
      />

      {/* Long term effect */}
      <RouterRoute
        path="/longterm-effect"
        element={<LongTermEffectsPages isSubscribed={subscriptionLevels.lt} />}
      />

      {/* Settings page */}
      <RouterRoute path="/settings" element={<SettingsPage />} />

      {/* Data Upload page */}
      <RouterRoute path="/data-upload" element={<DataUploadPage />} />

      {/* Brand Tracking */}
      <RouterRoute
        path="/brand-tracking"
        element={<BrandTrackingPages isSubscribed={subscriptionLevels.sos} />}
      />

      {/* Goals */}
      <RouterRoute path="/goals-and-targets" element={<GoalsPage />} />

      {/* Inbox */}
      <RouterRoute path="/inbox/*" element={<InboxPage />} />

      {/* Invite users dashboard */}
      {/* {isSuperuser && ( */}
      <RouterRoute
        path="/invite-users"
        element={<AdminInviteUsersDashboard />}
      />
      {/* )} */}

      {/* Misc pages */}
      <RouterRoute path="/" element={<RootNavigation />} />
      <RouterRoute path="*" element={<Page404 />} />
    </Routes>
  );
};
